<div class="container" [ngClass]="{'mode-pending-response': pendingresponse}">
    <div class="line first">
        <div class="title">
            <span *ngIf="pendingresponse" class="titlequestion">{{'SHARED.ROUTEPROPERTY.TITLE' | translate}}</span>
            <span *ngIf="!pendingresponse">{{'SHARED.ROUTE.PROPERTY.COMPONENT.TITLE' | translate}}</span>
        </div>
        <actions [actionstrip]="actions" (clickAction)="onClickAction($event)"></actions>
    </div>
    <div class="line help">
        <span *ngIf="pendingresponse">{{'SHARED.ROUTEPROPERTY.HELP' | translate}}</span>
        <span *ngIf="!pendingresponse">{{'SHARED.ROUTE.PROPERTY.COMPONENT.HELP' | translate}}</span>
    </div>
    <div class="header search">
        <input class="searchbox" placeholder="{{'SEARCH'| translate}}" type=text [(ngModel)]="searchText">
        <actions [actionstrip]="actions" (clickAction)="onClickAction($event)"></actions>
    </div>
    <div class="body">
        <shared-route-property [pendingresponse]="pendingresponse" [driver]="driver" [exwork]="exwork" [uuid]="uuid" [routeId]="routeId"
            [value]="property" [readonly]="readonly" (updateList)="onUpdateList($event)"
            *ngFor="let property of properties | filter:searchText | sortBy: 'order'">
        </shared-route-property>
    </div>

    <shared-savebutton class="botodesar" [showIcon]="true" (save)="save($event)" [readonly]="!canSave()">
        {{'SHARED.ROUTEPROPERTIES.BUTTON.SAVE' | translate}}
    </shared-savebutton>


</div>